export class ActivationStatus {
    id: number;
    active: boolean;

    constructor(pId: number, pActive: boolean) {
        this.id = pId;
        this.active = pActive;
    }
}
